import apiClient from './apiClient';

/**
 * Alle Abwesenheiten laden
 */
export const getAllAbwesenheiten = async (params = {}) => {
  const response = await apiClient.get('/abwesenheiten', { params });
  return response.data;
};

/**
 * Abwesenheiten für Kalender laden
 */
export const getKalenderAbwesenheiten = async (startDatum, endDatum) => {
  const response = await apiClient.get('/abwesenheiten/kalender', {
    params: { startDatum, endDatum }
  });
  return response.data;
};

/**
 * Heutige Abwesenheiten laden
 */
export const getHeuteAbwesenheiten = async () => {
  const response = await apiClient.get('/abwesenheiten/heute');
  return response.data;
};

/**
 * Abwesenheiten dieser Woche laden
 */
export const getWocheAbwesenheiten = async () => {
  const response = await apiClient.get('/abwesenheiten/woche');
  return response.data;
};

/**
 * Eigene Abwesenheiten laden
 */
export const getMeineAbwesenheiten = async (jahr) => {
  const response = await apiClient.get('/abwesenheiten/meine', {
    params: jahr ? { jahr } : {}
  });
  return response.data;
};

/**
 * Urlaubstage-Statistik laden
 */
export const getStatistik = async (jahr) => {
  const response = await apiClient.get('/abwesenheiten/statistik', {
    params: jahr ? { jahr } : {}
  });
  return response.data;
};

/**
 * Offene Anträge laden (Admin)
 */
export const getOffeneAntraege = async () => {
  const response = await apiClient.get('/abwesenheiten/antraege');
  return response.data;
};

/**
 * Neue Abwesenheit erstellen
 */
export const createAbwesenheit = async (data) => {
  const response = await apiClient.post('/abwesenheiten', data);
  return response.data;
};

/**
 * Abwesenheit aktualisieren
 */
export const updateAbwesenheit = async (id, data) => {
  const response = await apiClient.put(`/abwesenheiten/${id}`, data);
  return response.data;
};

/**
 * Abwesenheit löschen
 */
export const deleteAbwesenheit = async (id) => {
  const response = await apiClient.delete(`/abwesenheiten/${id}`);
  return response.data;
};

/**
 * Abwesenheit genehmigen (Admin)
 */
export const genehmigenAbwesenheit = async (id) => {
  const response = await apiClient.put(`/abwesenheiten/${id}/genehmigen`);
  return response.data;
};

/**
 * Abwesenheit ablehnen (Admin)
 */
export const ablehnenAbwesenheit = async (id, ablehnungsgrund) => {
  const response = await apiClient.put(`/abwesenheiten/${id}/ablehnen`, { ablehnungsgrund });
  return response.data;
};

export default {
  getAllAbwesenheiten,
  getKalenderAbwesenheiten,
  getHeuteAbwesenheiten,
  getWocheAbwesenheiten,
  getMeineAbwesenheiten,
  getStatistik,
  getOffeneAntraege,
  createAbwesenheit,
  updateAbwesenheit,
  deleteAbwesenheit,
  genehmigenAbwesenheit,
  ablehnenAbwesenheit
};
